import { render, staticRenderFns } from "./Ineris.vue?vue&type=template&id=03c3860e"
import script from "./Ineris.vue?vue&type=script&lang=js"
export * from "./Ineris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports